// @core/api/endpoints/document/get_document_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentTypeDefinitionResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Get document type
 * Returns a document type definition by ID or slug.
 */
export async function GetDocumentType(
  type_id: string,
  options?: RequestOptions
): Promise<DocumentTypeDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.get<DocumentTypeDefinitionResponse>(requestPath, { ...requestOptions });
}
